import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PostingsApi from '../../../../API/shipment/postings-api';
import { addShipmentPostings } from '../../../../actions/postings';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Content } from '../../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../../components/Basic/Table';
import { H1, Text } from '../../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_RUS, WAREHOUSES } from '../../../../constans';
import ExpressLine from './Line';
import styles from './styles.module.scss';

const SHOPS = {
  Ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  Yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  Wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  Megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '220px', // 11
  '80px', // 12
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];
const STATUSES_ORDERS_WB = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];
const STATUSES_ORDERS_OZON = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
];

const STATUSES_ORDERS_YANDEX = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];
const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

const STATUSES_ORDERS_SBER = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];
const STATUSES_ORDERS = {
  Ozon: STATUSES_ORDERS_OZON,
  Yandex: STATUSES_ORDERS_YANDEX,
  Wb: STATUSES_ORDERS_WB,
  SBER: STATUSES_ORDERS_SBER,
  'Не выбрана': [
    'Не выбран',
    'Ожидает отгрузки',
    'Доставляется',
    'Продано',
    'Прибыл на ПВЗ',
    'Не принят на CЦ',
    'Арбитраж',
    'Отменено',
    'Отменено клиентом',
    'Обнаружен брак',
  ],
};

const FILTER = {
  0: 'wb_express_all',
  1: 'wb_express_awaiting_shipment',
  2: 'wb_express_delivering',
  3: 'wb_express_sold',
  4: 'wb_express_canceled',
};

const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 90 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

function WbExpressPage() {
  const user = useSelector((store) => store.user);
  const [market, setMarket] = useState(MARKETS_LIST[0]);
  const [postingsPrint, setPostingsPrint] = useState({});

  const [sklad, setSklad] = useState(SKLAD_LIST[0]);
  const [saleSchema, setSaleSchema] = useState('fbs');
  const [period, setPeriod] = useState({ start: CalcMonthAgo(), end: CalcFeatureTwoDay() });

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [status, changeStatus] = useState(STATUSES[0]);
  const [orderStatus, changeOrderStatus] = useState('Не выбран');
  const [shop, setShop] = useState('Все');

  const { ids, byIds, map } = useSelector((store) => store.postings);
  const dispatch = useDispatch();

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const loadData = () => {
    PostingsApi.getWbExpress({
      data: {
        limit: parseInt(show),
        page,
        search: search.trim(),
        providerId: provider.id,
        tab: FILTER[tab],
        shop: shop === 'Все' ? undefined : shop.toLowerCase(),
        period: {
          createStartDate: period.start,
          createEndDate: period.end,
        },
        sortType: 'allorders',
        skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
        filters: {
          orderStatus: orderStatus === 'Не выбран' ? undefined : orderStatus,
          productsStatus: status === 'Не выбран' ? undefined : status,
        },
      }
    })
      .then((res) => {
        const { postings, cardsMap = {}, count, all_count = {} } = res;

        setCount(count);
        setCountStock([
          all_count.wb_express_all,
          all_count.wb_express_awaiting_shipment,
          all_count.wb_express_delivering,
          all_count.wb_express_sold,
          all_count.wb_express_canceled,
          ,
        ]);
        const ids = postings.map((item) => item.posting_number);
        postings.forEach((item) => (byIds[item.posting_number] = item));

        dispatch(addShipmentPostings({ byIds, ids, map: cardsMap }));
      })
      .catch();
  };

  useEffect(() => {
    loadData();
  }, [tab, show, search, provider.id, market, shop, status, orderStatus, period, sklad, saleSchema]);

  const changePostingPrint = (posting_number) => {
    if (postingsPrint[posting_number]) {
      const s = postingsPrint;
      delete s[posting_number];
      setPostingsPrint({ ...s });
    } else {
      setPostingsPrint({ ...postingsPrint, [posting_number]: true });
    }

    //setPostingsPrint({ ...postingsPrint, [order_number]: !postingsPrint[order_number] });
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  useEffect(() => {
    setShop('Все');
  }, [market]);

  return (
    <Content>
      <H1>Wildberries express</H1>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все заказы', 'Ожидают отгрузки', 'Доставляются', 'Продано', 'Отмены']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>
        <Input
          value={search}
          ref={inputRef}
          onBlur={(v) => setSearch(v)}
          onClickEnter={(v) => setSearch(v)}
          label="Поиск"
        />
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row style={{ height: '40px' }}>
            <div>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
            </div>
            <Select
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              width="200px"
              onSelect={(v) => changeProvider(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Статус заказа"
              select={orderStatus}
              list={STATUSES_ORDERS[market]}
              width="200px"
              onSelect={(v) => changeOrderStatus(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SKLAD_LIST}
              select={sklad}
              label="Склад отгрузки"
              onSelect={(v) => setSklad(v)}
              width={'200px'}
            />
          </Row>
          <Row>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.start}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                />
              </Row>
            </Column>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Конец периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.end}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                />
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>

      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[12]} centerText>
            Дата заказа
          </HeaderTitle>

          <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>

          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Статус заказа
          </HeaderTitle>

          <HeaderTitle width={WIDTH_POSTING[4]} centerText>
            Плановая дата доставки
          </HeaderTitle>
        </TableHeader>
        {ids.map((order) => {
          return (
            <ExpressLine
              order={byIds[order]}
              map={map}
              tab={tab}
              key={byIds[order].posting_number}
              setInputFocus={setInputFocus}
              postingsPrint={postingsPrint}
              changePostingPrint={changePostingPrint}
            />
          );
        })}
      </Table>
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
    </Content>
  );
}

export default WbExpressPage;
